import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { NoDataText } from './SidebarSection';

export const PostListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const PostItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.375rem 0;
  border-bottom: 1px solid #f3f4f6;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const PostTitle = styled.div`
  color: #111827;
  font-size: 0.8rem;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  &:hover {
    color: #ef4444;
  }
`;

export const CommentCount = styled.span`
  color: #6b7280;
  font-size: 0.7rem;
  margin-left: 0.5rem;
`;

export const PostDate = styled.span`
  color: #6b7280;
  font-size: 0.7rem;
  margin-left: 0.5rem;
`;

interface Post {
  post_id: number;
  title: string;
  createdAt: string;
  commentCount: number;
}

interface PostListProps {
  posts: Post[];
  noDataText?: string;
}

const PostList: React.FC<PostListProps> = ({ posts, noDataText = '게시물이 없습니다.' }) => {
  const navigate = useNavigate();
  const onClickPost = (postId: number) => {
    navigate(`/posts/${postId}`);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  return (
    <PostListContainer>
      {posts.length > 0 ? (
        posts.map(post => (
          <PostItem key={post.post_id}>
            <PostTitle onClick={() => onClickPost(post.post_id)}>
              {post.title}
              {post.commentCount > 0 ? <CommentCount>[{post.commentCount}]</CommentCount> : null}
            </PostTitle>
            <PostDate>
              {new Date(post.createdAt).toLocaleDateString().slice(5)}
            </PostDate>
          </PostItem>
        ))
      ) : (
        <NoDataText>{noDataText}</NoDataText>
      )}
    </PostListContainer>
  );
};

export default PostList; 